// extracted by mini-css-extract-plugin
module.exports = {"pricing":"Pricing_pricing__3VVyC","price":"Pricing_price__2JtsS","info":"Pricing_info__2jcN_","footer":"Pricing_footer__pDIyd"};